<template>
  <IconLucideCircleDollarSign />
</template>
